// extracted by mini-css-extract-plugin
module.exports = {"container":"DashboardContentBox_container__37KR7"};